import { render } from "./UpdatePrefence.vue?vue&type=template&id=590c2ef7"
import script from "./UpdatePrefence.vue?vue&type=script&lang=js"
export * from "./UpdatePrefence.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__